import { render, staticRenderFns } from "./MessagesSent.vue?vue&type=template&id=c02f0d42&"
import script from "./MessagesSent.vue?vue&type=script&lang=js&"
export * from "./MessagesSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports